import {Link} from 'react-router-dom'
import {FaStar} from 'react-icons/fa'
import {MdLocationOn} from 'react-icons/md'
import {BsFillBriefcaseFill} from 'react-icons/bs'
import './index.css'

const JobsList = props => {
  const {lis} = props

  return (
    <Link to={`/jobs/${lis.id}`} className="link">
      <div className="jlmdiv">
        <div className="logodiv">
          <img alt="company logo" className="logo" src={lis.companyLogoUrl} />
          <div>
            <h1>{lis.title}</h1>
            <div className="starrow">
              <FaStar className="star" />
              <p>{lis.rating}</p>
            </div>
          </div>
        </div>
        <div className="locodiv">
          <div className="row">
            <div className="row">
              <MdLocationOn className="m" />
              <p>{lis.location}</p>
            </div>
            <div className="row">
              <BsFillBriefcaseFill className="m" />
              <p>{lis.employmentType}</p>
            </div>
          </div>
          <div>
            <p>{lis.packagePerAnnum}</p>
          </div>
        </div>
        <hr className="line" />
        <div>
          <h1>Description</h1>
          <p>{lis.jobDescription}</p>
        </div>
      </div>
    </Link>
  )
}

export default JobsList
